import request from '@/utils/request'
import appRequest from '@/utils/appRequest'

import ZCRequest from '@/utils/zhichongRequest'

// 用户下单
export function placeAnOrder(params) {
  return request({
    url: '/payCon/userOrderPay/placeAnOrder',
    method: 'post',
    params
  })
}

// 前端 支付状态查询
export function checkPay(params) {
  return request({
    url: '/payCon/userOrderPay/checkPay',
    method: 'post',
    noLoading:true,
    params
  })
}
// APP 支付状态
export function appcheckPay(data) {
  return appRequest({
    url: 'v342/Topup/selectKbz',
    method: 'post',
    noLoading:true,
    data
  })
}

// 直充支付状态查询

export function ZCcheckPay(data) {
  return ZCRequest({
    url: 'v342/Topup/selectKbz',
    method: 'post',
    noLoading:true,
    data
  })
}

// 餐饮订单支付下单
export function cateringOrderPlaceAnOrder(params) {
  return request({
      url: '/payCon/cateringOrderPay/cateringPlaceAnOrder',
      method: 'post',
      params
  })
}

// 餐饮订单支付查询
export function cateringOrderCheck(params) {
  return request({
      url: '/payCon/cateringOrderPay/cateringOrderCheck',
      method: 'post',
      noLoading:true,
      params
  })
}

// 全球充订单支付下单（前端唤起支付）
export function payPhoneRechargeConsume(params) {
  return request({
    url: '/payCon/userOrderPay/pay4PhoneRechargeConsume',
    method: 'post',
    params
  })
}